import React from 'react';
import lodash from "lodash";
import Services from './../services/services';
import Steps from './../basics/Steps';
import ShopHeader from './ShopHeader';
import Notification from './../basics/Notification';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState, } from 'react';
import { useParams, useNavigate } from "react-router-dom";

const Cart = () => {

  const services = new Services();

  let id: any = localStorage.getItem('orderId');

  let intId: any = localStorage.getItem('orderIdInt');

  const [checkout, setCheckout] = useState<string>('disabled');

  const [checkoutState, setCheckoutState] = useState<any>(<div className="text-primary">Vyplňte údaje všech letenek</div>);

  const navigate = useNavigate();

  const [products, setProducts] = useState<any[]>([]);

  const [price, setPrice] = useState<any>();

  const [voucher, setVoucher] = useState<any>('');

  const [voucherState, setVoucherState] = useState<any>();

  const [voucherSet, setVoucherSet] = useState<any>(false);

  const [notification, setNotification] = useState<any>();

  const [checkoutButton, setCheckoutButton] = useState(<button className={ "btn btn-lg rounded-pill btn-primary w-100 my-3 disabled " + checkout } onClick={() => handleCheckout()} >Přejít k pokladně</button>);

  const [lastProducts, setLastProducts] = useState<any[]>([]);

  const [checkoutCard, setCheckoutCard] = useState(<div></div>);

  const [productsCard, setProductsCard] = useState(<div></div>);

  useEffect(()=>{
    services.getCart(id).then( (value: any) => {
      console.log(value)
      setProducts(value.items)
      setPrice(value.sum)
      if(value.voucher !== null){
        setVoucher(value.voucher.label)
        setVoucherSet(true)
      }

      console.log('produkty')
      console.log(value.items)
    })
  }, [])

  useEffect(()=>{

    console.log('changed',voucher);

  }, [voucher])

  useEffect(()=>{

    if(products.length > 0){

      setProductsCard(

            <div className="card-body d-flex flex-column justify-content-between">
              <div className="fs-4 text-primary montserrat"><strong>Můj košík</strong></div>
              <div>{cartItems}</div>

            </div>
      );

      let filled = true;

      products.forEach((item: any) =>{
        if( item.firstname == null || item.lastname == null){
          filled = false;
        }
      })

      if(!filled){
        setCheckout('disabled')
      }else{
        setCheckout('')

        setCheckoutState([<div className="text-dark">Letenky jsou připraveny k nákupu</div>])
      }

    }else{

      setCheckoutCard(<div></div>);

      setProductsCard(<div className="d-flex justify-content-center"><span className="fs-2 fw-bold text-primary my-5">Košík je prázdný</span></div>);

      setCheckout('disabled')

    }

  }, [products])

  const cartItems: any[] = [];

  products.forEach((data: any, index: any) => {

    let imageLink:any = '';
    let itemPlace:any = '';
    let firstname_message:any = '';
    let lastname_message:any = '';

    if( data.product.attachment.length > 0){

      imageLink = <div className="img-container-1-1 img-container custom-radius"><img className="card-img-top" src={ 'http://api-balony.techcrowd.space/' + data.product.attachment[0].path } /></div>;

    }

    if( data.place !== null){

      itemPlace = <div>{data.productPlace}</div>;

    }

    if( data.firstname == null ){ firstname_message = 'Vyplňte jméno' }
    if( data.lastname == null ){ lastname_message = 'Vyplňte příjmení' }

    cartItems.push(
      <div className='row my-4' id={data.id}>

        <div className="col-12 col-lg-2">
          {imageLink}
        </div>

        <div className="col-12 col-lg-8 ps-lg-5 pt-5 pt-lg-0 d-flex flex-column justify-content-between">
          <strong className="text-primary">{data.product.price} kč</strong>
          <div className="fs-2"><Link className=" text-dark text-decoration-none" to={ "/product-detail/"+data.product.id } >{data.product.name}</Link></div>
          <div className="d-flex flex-row">Místo odletu: {itemPlace}</div>
          <form className="row mt-2">
          <div className="col-12 col-lg-6">
            <input className="form-control form-control-bg border-0" name="firstname" onChange={(e) => { debounce(data.id, e.target.name, e.target.value, index) }} onBlur={(e) => { onEdit(data.id, e.target.name, e.target.value, index ) }} type="text" placeholder={data.firstname || 'Jméno pasažéra'} aria-label=".form-control-lg example" />
            <small className="text-primary">{firstname_message}</small>
          </div>
          <div className="col-12 col-lg-6">
            <input className="form-control form-control-bg border-0 mt-2 mt-lg-0" name="lastname" onChange={(e) => { debounce(data.id, e.target.name, e.target.value, index ) }} onBlur={(e) => { onEdit(data.id, e.target.name, e.target.value, index ) }} type="text" placeholder={data.lastname || 'Příjmení pasažéra'} aria-label=".form-control-lg example" />
            <small className="text-primary">{lastname_message}</small>
          </div>
          </form>
        </div>
        <div className="col-12 col-lg-2">
          <button className="float-end btn btn-link text-secondary text-decoration-none p-0 m-0" onClick={() => { onDelete(data.id,data.product.name) }}><i className="text-muted fa-solid fa-xmark"></i></button>
        </div>
        <hr className="mt-4" />
      </div>
    )
  })

  const onDelete = (id: any, name: any) => {

    console.log('test');
    console.log(id);

    let orderId: any = localStorage.getItem('orderId');

      services.dropCartItem(id).then( (value: any) => {

    });

    const newProducts = products.filter((item) => item.id !== id);

    setProducts(newProducts)

    let newPrice = 0

    newProducts.forEach((product) => { newPrice = newPrice + product.productPrice })

    setPrice(newPrice)

    setNotification(<Notification text={ "Produkt \""+name+"\" byl odstraněn z košíku"}/>)

  }

  const onEdit = (itemId: any, key: string, value: any, index: any) => {

    let change = {
      firstname: products[index].firstname,
      lastname: products[index].lastname,
      weight: products[index].weight,
      isPrint: products[index].isPrint
    }

    if( key == 'firstname' ){ change.firstname = value; products[index].firstname = value; }
    if( key == 'lastname' ){ change.lastname = value; products[index].lastname = value; }

    console.log(change);

    services.updateCartItem(id, itemId, change).then( (value: any) => {

      setProducts(value.data.items)

      console.log('LastProducts: ');

      console.log(value.data.items)

    })

  }

  let handleCheckout = () => {

    if( products.length > 0 ){

      navigate('/checkout',{state:{}});

    }

  }

  const voucherChange = (event: any) => {

    setVoucher(event.target.value)

    console.log('voucher',event.target.value);

    // setVoucherState('')

  }

  const submitVoucherForm = (event: any) => {

    console.log('vkládaný voucher',voucher)

    event.preventDefault();

    services.addVoucher(Number(intId), voucher).then( (value: any) => {

      if( value !== 'error' ){

        setPrice(value.sum)

        setVoucherState('Úspěšně vloženo');

        setVoucherSet(true)

      }else{

        setVoucherState('Zadaný kupón není platný');

      }

    });

  }

  const removeVoucher = (event: any) => {

    console.log('odstraňování');

    event.preventDefault();

    services.removeVoucher(intId).then( (value: any) => {

      setPrice(value.sum)

      setVoucherState('Kupón byl odstraněn');

      setVoucherSet(false)

      setVoucher('')

    });

  }

  const debounce = lodash.debounce(onEdit, 1000)

  const steps = [

    {'name':'Košík', 'link':'', 'active': false},
    {'name':'Pokladna','link': '', 'active': true},
    {'name':'Shrnutí','link': '', 'active': true},

  ];

  return (
    <div className="mb-5">

      <ShopHeader title="Košík" image='http://balony.techcrowd.space/cart.jpg'/>

      <div className="container pb-2">

        {notification}

        <Steps links={steps} />

        <div className="row">

        <div className="col-12 col-lg-8 mb-5">

          <div className="card border-0 custom-radius custom-shadow px-4 py-4">

          {productsCard}
          <div className="fs-5 montserrat">Máte slevový kupón?</div>
          <small className="text-primary">{voucherState}</small>
          <div className="row">
          <form className="col-12 col-lg-6" onSubmit={submitVoucherForm}>

            <div className="d-flex flex-row">
              <input type="text" className="form-control form-control-bg border-0" placeholder="Vložte kupón" name="voucher" value={voucher} onChange={event => voucherChange(event)} disabled={voucherSet} />
              {!voucherSet && (<button className="btn btn-primary ms-3 rounded-pill" type="submit" onClick={event => submitVoucherForm(event)} id="button-addon2">Vložit</button>)}
              {voucherSet && (<button className="btn btn-link ms-1 text-secondary" onClick={event => removeVoucher(event)} id="button-addon2"><i className="fa-regular fa-circle-xmark fa-2xl"></i></button>)}
            </div>

          </form>

          </div>
          </div>

        </div>

          <div className="col-12 col-lg-4">

          <div className="card border-0 custom-radius custom-shadow px-3 py-4">
            <div className="card-body d-flex flex-column justify-content-between">
              {checkoutState}
              <hr />
              <div className="fs-4 d-flex justify-content-between montserrat"><strong className="text-primary">Cena celkem </strong><strong>{price} Kč</strong></div>

              <button className={ "btn btn-lg rounded-pill btn-primary w-100 my-3 " + checkout } onClick={() => handleCheckout()} >Přejít k pokladně</button>
              
            </div>
          </div>

          </div>

        </div>

      </div>

    </div>
  );

}

export default Cart;
